interface ProcessCounts {
  total: number;
  negative: number;
  positive: number;
  unable: number;
}

/**
 * Clinical-safety speed bump before a whole testing batch is submitted to Review. Because every box
 * starts green (Negative), a bench user can "Process all" without ever touching an individual member -
 * sending all of them as Negative-by-default. This interstitial states how many are going in as
 * Negative with no per-member tap and forces an explicit confirm. The second-person Review/approve
 * gate still stands behind it; this is the first-person acknowledgment.
 */
export function ProcessConfirmDialog({
  counts,
  processing,
  onConfirm,
  onCancel,
}: {
  counts: ProcessCounts;
  processing: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="modal-scrim" role="dialog" aria-modal="true" aria-labelledby="process-confirm-title">
      <div className="modal tier-2" style={{ padding: '22px 22px 20px' }}>
        <div id="process-confirm-title" className="mb-2 text-lg font-semibold text-cdx-fg-strong">
          Submit batch to Review?
        </div>
        <p className="mb-4 text-sm" style={{ color: 'var(--ink-700)', lineHeight: 1.55 }}>
          You are submitting <span className="font-semibold tab-num">{counts.total}</span>{' '}
          {counts.total === 1 ? 'member' : 'members'}.{' '}
          <span className="font-semibold" style={{ color: 'var(--emerald)' }}>
            {counts.negative}
          </span>{' '}
          will be recorded as{' '}
          <span className="font-semibold" style={{ color: 'var(--emerald)' }}>
            Negative by default
          </span>{' '}
          with no per-member tap. This batch then goes to a second reviewer for approval.
        </p>
        <div className="card card-sunken mb-5" style={{ padding: '4px 14px' }}>
          <div className="leader-row">
            <span className="k">Negative</span>
            <span className="leader" />
            <span className="v">{counts.negative}</span>
          </div>
          <div className="leader-row">
            <span className="k">Positive</span>
            <span className="leader" />
            <span className="v">{counts.positive}</span>
          </div>
          <div className="leader-row">
            <span className="k">Unable to test</span>
            <span className="leader" />
            <span className="v">{counts.unable}</span>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={processing}
            className="btn-bench btn-bench-ghost flex-1 disabled:opacity-50"
          >
            Go back
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={processing}
            className="btn-bench flex-1 disabled:opacity-50"
          >
            {processing ? 'Submitting...' : 'Confirm and submit'}
          </button>
        </div>
      </div>
    </div>
  );
}
